import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { baseUrl } from "../../utils/APi";
import { getGallery } from "../../store/home/homeAction";
import { LazyLoadImage } from "react-lazy-load-image-component";
import img1 from "../../assets/main/5.jpg";
import img2 from "../../assets/main/2.jpg";
import img3 from "../../assets/main/6.jpg";
const Blog = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lan = useSelector((state) => state.LanSlicer.language);
  const { gallery } = useSelector((state) => state.homeSlicer);
  useEffect(() => {
    if (!gallery?.length) {
      const promise = dispatch(getGallery());
      return () => {
        promise.abort();
      };
    }
  }, [lan, dispatch, gallery?.length]);

  return (
    <section className="flat-latest">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="section-title wow fadeInDown">
              <h4 className="section-subtitle">Latest News</h4>
              <h2 className="section-main-title section-45px-montserrat">
                Latest Blog Posts
              </h2>
            </div>
          </div>
          <div className="col-md-4">
            <div
              className="latest-new-box grow-up-hover wow fadeInUp"
              data-wow-delay="0ms"
              data-wow-duration="1500ms"
            >
              <div className="latest-post">
                <img src={img1} className="grow-up-hover" alt="images" />
              </div>
              <div className="latest-content">
                <div className="latest-info link-style-6 margin-bottom-10">
                  <span>
                    <a
                      href="blog.html"
                      className="author-post section-14px-regular font-weight-500"
                    >
                      Personal
                    </a>
                  </span>
                  <span>
                    <a
                      href="blog.html"
                      className="date-post section-14px-regular font-weight-500"
                    >
                      June 13, 2021
                    </a>
                  </span>
                </div>
                <div className="latest-title margin-bottom-20">
                  <a
                    href="blog-single.html"
                    className="section-20px-montserrat"
                  >
                    Lights winged seasons fish abundantly.
                  </a>
                </div>
                <div className="latest-readmore">
                  <a href="blog-single.html" className="read-more"></a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div
              className="latest-new-box grow-up-hover wow fadeInUp"
              data-wow-delay="300ms"
              data-wow-duration="1500ms"
            >
              <div className="latest-post">
                <img src={img2} className="grow-up-hover" alt="images" />
              </div>
              <div className="latest-content">
                <div className="latest-info link-style-6 margin-bottom-10">
                  <span>
                    <a
                      href="blog.html"
                      className="author-post section-14px-regular font-weight-500"
                    >
                      Personal
                    </a>
                  </span>
                  <span>
                    <a
                      href="blog.html"
                      className="date-post section-14px-regular font-weight-500"
                    >
                      June 13, 2021
                    </a>
                  </span>
                </div>
                <div className="latest-title margin-bottom-20">
                  <a
                    href="blog-single.html"
                    className="section-20px-montserrat"
                  >
                    Winged moved stars, fruit creature seed night.
                  </a>
                </div>
                <div className="latest-readmore">
                  <a href="blog-single.html" className="read-more"></a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div
              className="latest-new-box grow-up-hover wow fadeInUp"
              data-wow-delay="600ms"
              data-wow-duration="1500ms"
            >
              <div className="latest-post">
                <img src={img3} className="grow-up-hover" alt="images" />
              </div>
              <div className="latest-content">
                <div className="latest-info link-style-6 margin-bottom-10">
                  <span>
                    <a
                      href="blog.html"
                      className="author-post section-14px-regular font-weight-500"
                    >
                      Personal
                    </a>
                  </span>
                  <span>
                    <a
                      href="blog.html"
                      className="date-post section-14px-regular font-weight-500"
                    >
                      June 13, 2021
                    </a>
                  </span>
                </div>
                <div className="latest-title margin-bottom-20">
                  <a
                    href="blog-single.html"
                    className="section-20px-montserrat"
                  >
                    Given void great you’re good appear also fifth.
                  </a>
                </div>
                <div className="latest-readmore">
                  <a href="blog-single.html" className="read-more"></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
